import React, { useEffect, useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import { onlyInteger } from 'hooks/Pipe';
export default function ModalUpdateGuide({ guide }) {
  const [docTypes, setDocTypes] = useState([]);

  async function listDocTypes() {
    let response = await wsFindBy('base/sunat-document-type/prt', { type: 'guide' });
    if (response.success) setDocTypes(response.data);
  }
  useEffect(() => {
    listDocTypes();
  }, []);

  return (
    <>
      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel>Tipo documento</InputLabel>
        <Select
          inputProps={{
            name: 'ReceiptType'
          }}
          defaultValue=""
        >
          {docTypes.map((item) => (
            <MenuItem key={item.id} value={item.code}>
              {item.description}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Serie"
        fullWidth
        name="ReceiptSerie"
        margin="normal"
        size="small"
        required
        defaultValue=""
        inputProps={{ maxLength: 4 }}
      />
      <TextField
        label="Código"
        fullWidth
        name="ReceiptNumber"
        margin="normal"
        size="small"
        type="text"
        onKeyPress={onlyInteger}
        inputProps={{ maxLength: 8 }}
        required
        defaultValue=""
      />
    </>
  );
}
